<div class="table">
  <div class="table-header">
    <div *ngFor="let plug of loaderPlugsLength" class="data-grid-loader">
      <div class="loader-plug"></div>
    </div>
  </div>
  <div *ngFor="let plug of loaderPlugsLength" class="table-row">
    <div *ngFor="let plug of loaderPlugsLength" class="data-grid-loader">
      <div class="loader-plug"></div>
      <div class="loader-plug"></div>
      <div class="loader-plug"></div>
      <div class="loader-plug"></div>
      <div class="loader-plug"></div>
      <div class="loader-plug"></div>
    </div>
  </div>
</div>
